/**
 * Formats a number as currency using German locale and EUR currency
 * @param value - The number to format
 * @returns Formatted currency string
 */
export function currencyFormatter(value: number): string {
  if (!value && value !== 0) return '';

  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);
}
